import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Button from "../components/Button";
import Dialog from "../components/Dialog";

const UnsavedChangesDialogControls = styled.div`
  display: flex;
  gap: 2rem;
`;

const UnsavedCopy = styled.div`
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[3]}`};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${(props) => props.theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[4]};
  font-weight: 700;
  line-height: 1;
`;

const UnsavedChangesDialogCopy = styled.div`
  margin-bottom: ${(props) => props.theme.space[4]};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.white};
`;

interface IUnsavedChangesDialog {
  handleConfirm: () => void;
  handleHide: () => void;
}

const UnsavedChangesDialog: React.FC<IUnsavedChangesDialog> = ({
  handleConfirm,
  handleHide,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog closeDialog={handleHide}>
      <Dialog.Header closeDialog={handleHide}>
        <UnsavedCopy>
          {t("unsavedChangesModal.heading", "You have unsaved changes")}
        </UnsavedCopy>
      </Dialog.Header>
      <Dialog.Body isPadded={true}>
        <UnsavedChangesDialogCopy>
          {t(
            "unsavedChangesModal.body",
            "Are you sure you want to leave this page?",
          )}
        </UnsavedChangesDialogCopy>
        <UnsavedChangesDialogControls>
          <Button variant="primary" onClick={handleHide} width={1}>
            {t("unsavedChangesModal.negative", "No")}
          </Button>
          <Button variant="primary" onClick={handleConfirm} width={1}>
            {t("unsavedChangesModal.affirmative", "Yes")}
          </Button>
        </UnsavedChangesDialogControls>
      </Dialog.Body>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
